import React from "react";
import { MdPhone } from "react-icons/md";
import styled from "styled-components/macro";
import { toRem } from "theme/Breakpoints";

interface PhoneButtonProps {}

const PhoneButton: React.FC<PhoneButtonProps> = ({}) => {
  return (
    <Call href="tel:+359-886-560510">
      <MdPhone color="white" size="1.5em" />
    </Call>
  );
};

const Call = styled.a`
  width: 100%;
  height: ${toRem(50)};
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;
export default PhoneButton;
